export const ROLES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  MANAGER: 'ROLE_MANAGER',
} as const;

/**
 * must contain 1 number (0-9)
 * must contain 1 uppercase letters
 * must contain 1 lowercase letters
 * must contain 1 non-alpha numeric number
 * is 14 characters min and unlimited with no space
 */
export const PASSWORD_REGEX =
  /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){14,}$/;

/**
 * Accepts international phone numbers:
 * - optional leading +
 * - digits, spaces, dashes, dots, parentheses
 * - at least 6 digits total
 * Examples: +33 1 23 45 67 89, 01.23.45.67.89, (0)6-12-34-56-78
 */
export const PHONE_REGEX = /^\+?[\d\s\-().]{6,}$/;

/**
 * Validates postal codes for common European formats:
 * - France: 5 digits (e.g. 75001)
 * - Germany: 5 digits (e.g. 10115)
 * - Belgium / Italy / Spain / Netherlands: 4-5 digits, optionally with letters or space
 *   (e.g. 1000, 1011 AB)
 * Accepts 4 to 10 alphanumeric characters (digits, letters, spaces, dashes).
 */
export const POSTAL_CODE_REGEX = /^[A-Za-z0-9][A-Za-z0-9\s\-]{2,9}$/;
